import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/apiClient'
import { USER_SESSION_QUERY_KEY } from './auth'

export function useSendVerificationEmail() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.post(
        '/v1/auth/email-verification/send'
      )
      return response.data as { sent: boolean }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [USER_SESSION_QUERY_KEY],
      })
    },
  })
}

export function useVerifyEmail() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (code: string) => {
      const response = await apiClient.post(
        '/v1/auth/email-verification/verify',
        { code }
      )
      return response.data as { verified: boolean }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [USER_SESSION_QUERY_KEY],
      })
    },
  })
}
